<template>
  <div class="uoofoxPage">
    <div class="uoofoxPage1" :style="{ background: 'url(' + imgList[0] + ') no-repeat center center'  }">
      <div style="width:1200px;height:480px;margin: auto;text-align: left;">
        <div style="width: 600px;margin-left: 70px;text-align:center;padding-top: 88px;">
          <div class="uoofoxPage35" :style="style1" v-html="testList[26]"></div>
          <div class="uoofoxPage36" style="margin-top: 30px;">
            <div class="uoofoxPage37" v-html="testList[21]"></div>
            <div class="uoofoxPage37" v-html="testList[22]"></div>
            <div class="uoofoxPage37" v-html="testList[23]"></div>
            <div class="uoofoxPage38"></div>
            <div class="uoofoxPage39"></div>
          </div>
          <a class="uoofoxPage40" href="https://www.ioofox.com/download/uoofox.apk">
            {{ testList[24] }}
          </a>
        </div>
      </div>

    </div>
    <div class="uoofoxPage4" style="width:1200px;margin:auto;position: relative;padding-top: 50px;">
      <div class="uoofoxPage5">
        <div style="padding-top: 120px;padding-left:40px;">
          <p style="font-size: 40px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FEFEFE;
            line-height: 40px;" v-html="testList[0]"></p>
          <p style="font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FEFEFE;
            line-height: 40px;padding-top: 30px;" v-html="testList[1]"></p>
        </div>
      </div>
      <div style="width:1200px;height:300px;text-align:right;">
        <div class="uoofoxPage14"></div>
        <p style="font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #20A7E6;
          opacity: 0.5;" v-html="testList[25]"></p>
        <p style="padding-top: 40px;font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #9A9EA0;
          line-height: 30px;" v-html="testList[2]"></p>
        <p style="padding-top: 10px;font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #9A9EA0;
          line-height: 30px;" v-html="testList[3]"></p>
        <p style="padding-top: 10px;font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #9A9EA0;
          line-height: 30px;" v-html="testList[4]"></p>
      </div>
      <div style="width:1200px;height:426px;display: flex;justify-content:space-between;z-index: 1000;">
        <div style="width:357px;height:426px;">
          <div class="uoofoxPage15">
            <div class="uoofoxPage16"></div>
            <span class="uoofoxPage17" v-html="testList[5]"></span>
          </div>
        </div>
        <div class="uoofoxPage6" :style="{ background: 'url(' + imgList[1] + ') no-repeat center center'  }">
          <div class="uoofoxPage7" v-html="testList[6]" style="color: #FF743D;">

          </div>
        </div>
        <div class="uoofoxPage18" :style="{ background: 'url(' + imgList[2] + ') no-repeat center center'  }">
          <div class="uoofoxPage7" v-html="testList[7]" style="color: #49CC81;">

          </div>
        </div>
        <div class="uoofoxPage19" :style="{ background: 'url(' + imgList[3] + ') no-repeat center center'  }">
          <div class="uoofoxPage7" v-html="testList[8]" style="color: #5B6AFF;">

          </div>
        </div>
      </div>
    </div>
    <div style="width:1200px;margin:auto;position: relative;padding-top: 50px;">
      <p style="font-size:40px;font-weight:600;padding: 40px 0 40px 0;" v-html="testList[9]"></p>
      <div style="width:100%;height: 800px;">
        <div style="width:100%;height:380px;position: relative;">
          <div class="uoofoxPage10">
            <span class="uoofoxPage41" style="display:block;padding-top: 60px;" v-html="testList[10]"></span>
          </div>
          <div class="uoofoxPage11">
            <span class="uoofoxPage41" style="display:block;padding-top: 60px;" v-html="testList[11]"></span>
          </div>
          <div class="uoofoxPage8" :style="{ background: 'url(' + imgList[4] + ') no-repeat center center'  }"></div>
          <div class="uoofoxPage9" :style="{ background: 'url(' + imgList[5] + ') no-repeat center center'  }"></div>
          <!-- <div class="uoofoxPage12 uoofoxPage41" v-html="testList[10]"></div> -->
          <!-- <div class="uoofoxPage13 uoofoxPage41" v-html="testList[11]"></div> -->
        </div>
        <div style="width:100%;height:400px;display: flex;justify-content: space-between;">
          <div style="width:400px;height:400px;position: relative;">
            <div class="uoofoxPage20" :style="{ background: 'url(' + imgList[6] + ') no-repeat center center'  }"></div>
            <div class="uoofoxPage23 uoofoxPage41" v-html="testList[12]"></div>
          </div>
          <div style="width:400px;height:400px;position: relative;">
            <div class="uoofoxPage21" :style="{ background: 'url(' + imgList[7] + ') no-repeat center center'  }"></div>
            <div class="uoofoxPage24 uoofoxPage41" v-html="testList[13]"></div>
          </div>
          <div style="width:400px;height:400px;position: relative;">
            <div class="uoofoxPage22" :style="{ background: 'url(' + imgList[8] + ') no-repeat center center'  }"></div>
            <div class="uoofoxPage25 uoofoxPage41" v-html="testList[14]"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="width:1200px;margin:auto;padding-bottom: 70px;">
      <p style="font-size:40px;font-weight:600;padding: 0 0 20px 0;" v-html="testList[15]"></p>
      <p style="font-size:25px;font-weight:200;padding: 0 0 40px 0;" v-html="testList[16]"></p>
      <div class="uoofoxPage26">
        <div class="uoofoxPage27">
          <div class="uoofoxPage28">
            <p v-html="testList[17]"></p>
            <div class="uoofoxPage29 uoofoxPage31"></div>
          </div>
          <div class="uoofoxPage28">
            <p v-html="testList[18]"></p>
            <div class="uoofoxPage29 uoofoxPage32"></div>
          </div>
        </div>
        <div class="uoofoxPage27" style="padding-top: 32px;">
          <div class="uoofoxPage30">
            <div class="uoofoxPage29 uoofoxPage33"></div>
            <p v-html="testList[19]"></p>
          </div>
          <div class="uoofoxPage30">
            <div class="uoofoxPage29 uoofoxPage34"></div>
            <p v-html="testList[20]"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gameBlock from "./component/gameBlock";
export default {
  name: "uoofoxPage",
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.changeLang(type);
    },
  },
  components: {
    gameBlock,
  },
  created: function () {
    //当前轮播索引
    this.currentLunBo = 0;
    //爆款游戏定时器
    this.baoktimer = null;

  },
  destroyed: function () {
  },
  mounted: function () {
    var lan = navigator.language;
    if (lan == 'zh-CN') {
      this.changeLang('zh')
    } else {
      this.changeLang('en')
    }
    this.getImg();
  },
  methods: {
    gameDev() {
      console.log("成为游戏开发者");
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 8 }).then((res) => {
        let arr = new Array();
        for (var index in res.data) {
          arr.push(this.$ip + res.data[index]["imgUrl"]);
        }
        this.imgList = arr;
      });
    },
    //修改语言
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 8 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for (var index in res.data) {
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
          this.style1 = {
            "font-size": '70px'
          }
        } else {
          let arr = new Array();
          for (var index in res.data) {
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
          this.style1 = {
            "font-size": '45px'
          }
        }
      });
    },
  },
  data() {
    return {
      baokGames: this.baokGames,
      gameBlocks: this.gameBlocks,
      testList: [],
      imgList: [],
      style1:{},
    };
  },
};
</script>

<style>
.uoofoxPage {
  width: 100%;
}

.uoofoxPage1 {
  background: url('../assets/uoofox/banner.jpg') no-repeat center center;
  width: 100%;
  height: 480px;
  margin: auto;
  /* position: relative; */
}

.uoofoxPage2 {
  position: absolute;
  top: 119px;
  left: 360px;
  font-size: 64px;
  font-family: sucaijishikufangti;
  font-weight: 400;
  color: #ffffff;
  text-shadow: 0px 4px 6px rgba(14, 176, 223, 0.2);
}

.uoofoxPage2 string {
  font-size: 48px;
}

.uoofoxPage3 {
  position: absolute;
  top: 233px;
  left: 360px;
  width: 620px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  /* opacity: 0.8; */
  text-align: left;
}

.uoofoxPage5 {
  width: 512px;
  height: 565px;
  position: absolute;
  background: url('../assets/uoofox/bg1.jpg') no-repeat center center;
  text-align: left;
  z-index: -1;
}

.uoofoxPage6 {
  background: url('../assets/uoofox/jiaru3.jpg') no-repeat center center;
  width: 277px;
  height: 400px;
}

.uoofoxPage18 {
  background: url('../assets/uoofox/jiaru4.jpg') no-repeat center center;
  width: 277px;
  height: 400px;
}

.uoofoxPage19 {
  background: url('../assets/uoofox/jiaru5.jpg') no-repeat center center;
  width: 277px;
  height: 400px;
}


.uoofoxPage7 {
  background: url('../assets/uoofox/bg3.png') no-repeat center center;
  margin-top: 300px;
  margin-left: -5px;
  width: 222px;
  height: 58px;
  line-height: 58px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}

.uoofoxPage8 {
  position: absolute;
  border-radius: 20px;
  background: url('../assets/uoofox/pinzhi1.jpg') no-repeat center center;
  width: 428px;
  height: 264px;
  left: 120px;
}

.uoofoxPage9 {
  position: absolute;
  border-radius: 20px;
  background: url('../assets/uoofox/pinzhi2.jpg') no-repeat center center;
  width: 428px;
  height: 264px;
  left: 670px;
}

.uoofoxPage10 {
  position: absolute;
  background: url('../assets/uoofox/bg5.png') no-repeat center center;
  width: 440px;
  height: 108px;
  top: 230px;
  left: 90px;
}

.uoofoxPage11 {
  position: absolute;
  background: url('../assets/uoofox/bg5.png') no-repeat center center;
  width: 440px;
  height: 108px;
  top: 230px;
  left: 640px;
}

.uoofoxPage12 {
  position: absolute;
  top: 290px;
  left: 190px;
  font-size: 20px;
  font-weight: 400;
}

.uoofoxPage13 {
  font-size: 20px;
  font-weight: 400;
  position: absolute;
  top: 290px;
  left: 760px;
}

.uoofoxPage14 {
  background: url('../assets/uoofox/uoofox.png') no-repeat center center;
  width: 257px;
  height: 54px;
  margin-right: 0;
  display: inline-block;
}

.uoofoxPage15 {
  position: relative;
  margin-left: 50px;
  margin-top: 250px;
  background: url('../assets/uoofox/jiaru.png') no-repeat center center;
  width: 276px;
  height: 146px;
}

.uoofoxPage16 {
  position: absolute;
  margin-top: 250px;
  background: url('../assets/uoofox/jiaru2.png') no-repeat center center;
  width: 28px;
  height: 24px;
  bottom: 28px;
  left: 40px;
}

.uoofoxPage17 {
  position: absolute;
  bottom: 28px;
  left: 80px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}

.uoofoxPage20 {
  border-radius: 20px;
  background: url('../assets/uoofox/pinzhi3.jpg') no-repeat center center;
  width: 380px;
  height: 264px;
  margin: auto;
}

.uoofoxPage21 {
  border-radius: 20px;
  background: url('../assets/uoofox/pinzhi4.jpg') no-repeat center center;
  width: 380px;
  height: 264px;
  margin: auto;
}

.uoofoxPage22 {
  border-radius: 20px;
  background: url('../assets/uoofox/pinzhi5.jpg') no-repeat center center;
  width: 380px;
  height: 264px;
  margin: auto;
}

.uoofoxPage23 {
  position: absolute;
  right: 0;
  left: 0;
  top: 210px;
  margin: auto;
  background: url('../assets/uoofox/pinzhi6.png') no-repeat center center;
  width: 364px;
  height: 120px;
  margin: auto;
  line-height: 120px;
  font-size: 20px;
}

.uoofoxPage24 {
  position: absolute;
  right: 0;
  left: 0;
  top: 210px;
  margin: auto;
  background: url('../assets/uoofox/pinzhi6.png') no-repeat center center;
  width: 364px;
  height: 120px;
  margin: auto;
  line-height: 120px;
  font-size: 20px;
}

.uoofoxPage25 {
  position: absolute;
  right: 0;
  left: 0;
  top: 210px;
  margin: auto;
  background: url('../assets/uoofox/pinzhi6.png') no-repeat center center;
  width: 364px;
  height: 120px;
  margin: auto;
  line-height: 120px;
  font-size: 20px;
}

.uoofoxPage26 {
  width: 1200px;
}

.uoofoxPage27 {
  display: flex;
  justify-content: space-between;
}

.uoofoxPage28,
.uoofoxPage30 {
  width: 584px;
  border-radius: 25px;
  background-color: rgba(48, 155, 255, 1);
}

.uoofoxPage28 p,
.uoofoxPage30 p {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin: 25px auto;
}

.uoofoxPage29 {
  width: 584px;
  height: 300px;
  background-size: 100%;
  background-position: center center;
  border-radius: 20px;
  transition: all 0.6s;
}

.uoofoxPage28:hover .uoofoxPage29,
.uoofoxPage30:hover .uoofoxPage29 {
  /* background-size: 120% !important; */
  background-size: 110%;
  /* animation: ani1 2s ease 0s 1 alternate forwards;
  -webkit-animation: ani1 2s ease 0s 1 alternate forwards; */
}

.uoofoxPage31 {
  background-image: url("../assets/uoofox/fenlei1.jpg");
  background-size: 100%;
  background-position: center center;
}

.uoofoxPage32 {
  background-image: url("../assets/uoofox/fenlei2.jpg");
  background-size: 100%;
  background-position: center center;
}

.uoofoxPage33 {
  background-image: url("../assets/uoofox/fenlei3.jpg");
  background-size: 100%;
  background-position: center center;
}

.uoofoxPage34 {
  background-image: url("../assets/uoofox/fenlei4.jpg");
  background-size: 100%;
  background-position: center center;
}

.uoofoxPage35 {
  margin: auto;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: 800;
  color: #FFFFFF;
  /* padding: 128px 0 0 124px; */
}

.uoofoxPage36 {
  width: 600px;
  height: 36px;
  display: flex;
  position: relative;
}

.uoofoxPage37 {
  width: 200px;
  height: 36px;
  background: url("../assets/uoofox/banner3.png") no-repeat center center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
}

.uoofoxPage38 {
  width: 40px;
  height: 40px;
  background: url("../assets/uoofox/banner4.png") no-repeat center center;
  position: absolute;
  top: 2px;
  left: 180px;
}

.uoofoxPage39 {
  width: 40px;
  height: 40px;
  background: url("../assets/uoofox/banner4.png") no-repeat center center;
  position: absolute;
  top: 2px;
  left: 380px;
}

.uoofoxPage40 {
  text-decoration: none;
  display: inline-block;
  margin-top: 50px;
  padding: 15px 50px;
  background-color: #ffffff;
  border-radius: 27px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0ab1ff;
  border: none;
  cursor: pointer;
  /* position: absolute;
  top: 286px;
  left: 636px; */
}

.uoofoxPage41 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #181818;
}
</style>



// WEBPACK FOOTER //
// src/components/uoofox.vue